<template>
  <div class="view view-registro view-pad-top">
    <top-bar v-if="isPortalReady" />
    <div class="site-content">
        <div class="container">
            <div class="row">
                <section class="col-sm-8 offset-sm-4 col-md-9 offset-md-3">
                    <div>
                        <h1 class="form-title">Recuperar Contraseña</h1>
                        <olvido-password-form
                            @olvido_password="olvido_password" />
                    </div>
                </section>
            </div>
        </div>
    </div>
    <site-footer v-if="isPortalReady" :verFooter="true"/>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import TopBar from "../components/TopBar";
import SiteFooter from "../components/SiteFooter";
import OlvidoPasswordForm from "../components/OlvidoPasswordForm";

export default {
	name: "olvido_password",
	components: {
		TopBar,
		SiteFooter,
		OlvidoPasswordForm
	},
	data() {
		return {
			seRegistro: false
		};
	},
	computed: {
		...mapState(["portal", "user", "site", "isPortalReady"]),
		...mapGetters(["userId"])
	},
	created() {
		setTimeout(() => {
			if (this.userId > 0) {
				this.$router.push({ name: "home" });
			}
		}, 1000);
	},
	watch: {
		userId(val, old) {
			if (old == 0 && val != 0) {
				this.$nextTick(() => {
					if (!this.site.didLoadUser && this.seRegistro) {
						// Entro directo a la página, no se cargó usuario ni se registro, al home.
						this.$router.push({ name: "perfil" });
					}
				});
			}
		}
	},
	methods: {
		olvido_password(user) {
			this.seRegistro = true;
		}
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			// Si ya está logueado y trata de entrar al registro, mandarlo al perfil.
			if (vm.user.id != 0) vm.$router.push({ name: "perfil" });
		});
	}
};
</script>
